export default __webpack_public_path__ + "static/media/close.958496c1.svg";